import { screenShareVisitors } from 'v2/actionTypes'

const initialState = { isFetching: false }

export default function (state = initialState, action) {
  switch (action.type) {
    case screenShareVisitors.loading:
      return action.payload
    default:
      return state
  }
}
